import { render, staticRenderFns } from "./rest_sheet.vue?vue&type=template&id=33313f10&scoped=true&"
import script from "./rest_sheet.vue?vue&type=script&lang=js&"
export * from "./rest_sheet.vue?vue&type=script&lang=js&"
import style0 from "./rest_sheet.vue?vue&type=style&index=0&id=33313f10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33313f10",
  null
  
)

export default component.exports